/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,no-undef */
import React from "react";
import SVG from "react-inlinesvg";
import {Link} from "react-router-dom";
import {toAbsoluteUrl} from "../../../../_helpers";
import {useSelector} from "react-redux";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSignOutAlt} from '@fortawesome/free-solid-svg-icons';

export function QuickUser() {
    const {user, avatar} = useSelector(state => state.auth);

    const getAvatar = () => {
        return avatar ? avatar : '/media/images/user_blank.png';
    }

    return (
        <div id="od_quick_user" className="offcanvas offcanvas-right offcanvas">
            <div className="offcanvas-header d-flex align-items-center justify-content-between p-5">
                <h6 className="font-weight-bold m-0">
                    My Profile
                </h6>
                <a href="#" id="od_quick_user_close"
                   className="btn btn-xs btn-icon btn-light btn-hover-primary">
                    <i className="ki ki-close icon-xs text-muted"/>
                </a>
            </div>

            <div className="offcanvas-content px-10 pt-6">
                <div className="d-flex align-items-center mt-5">
                    <div className="symbol symbol-100 mr-5">
                        <div className="symbol-label" style={{backgroundImage: `url(${getAvatar()})` }}></div>
                        <i className="symbol-badge bg-success"/>
                    </div>
                    <div className="d-flex flex-column">
                        <Link to="/welcome"
                              className="font-weight-bold font-size-h5 text-dark-75 text-hover-primary">
                            {user.firstname} {user.lastname}
                        </Link>

                        <div className="text-muted mt-1">{user.job_position || "-"}</div>

                        <div className={`navi mt-4`}>
                            <Link to="/logout"
                                  className="btn btn-sm btn-light-danger font-weight-bolder py-2 px-5 waves-effect waves-light">
                                <FontAwesomeIcon icon={faSignOutAlt}/> {' '} Sign out
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="separator separator-dashed mt-8 mb-5"/>

                <div className="navi navi-spacer-x-0 p-0">
                    <Link to="/user/my_profile" className="navi-item">
                        <div className="navi-link">
                            <div className="symbol symbol-40 bg-light mr-3">
                                <div className="symbol-label">
                                  <span className="svg-icon svg-icon-md svg-icon-success">
                                    <SVG src={toAbsoluteUrl("/media/svg/icons/General/Notification2.svg")}></SVG>
                                  </span>
                                </div>
                            </div>
                            <div className="navi-text">
                                <div className="font-weight-bold">My Profile</div>
                                <div className="text-muted">
                                    Personal information, reset password ...
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>

                <div className="separator separator-dashed my-7"></div>

            </div>
        </div>
    );
}
